import { apiClient } from '../shared/services/api';

export interface Message {
  id: string;
  conversationId: string;
  senderId: string;
  content: string;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface Conversation {
  id: string;
  participant1Id: string;
  participant2Id: string;
  lastMessageAt?: string;
  createdAt: string;
  updatedAt: string;
  unreadCount: number;
  otherParticipant: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullName: string;
    avatarUrl?: string;
  };
  lastMessage?: Message;
}

export interface SendMessageRequest {
  recipientId: string;
  content: string;
}

export interface PaginatedMessages {
  content: Message[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const chatAPI = {
  sendMessage: (data: SendMessageRequest) =>
    apiClient.post<Message>('/chat/messages', data),

  getConversations: () =>
    apiClient.get<Conversation[]>('/chat/conversations'),

  getConversationMessages: (conversationId: string, page = 0, size = 50) =>
    apiClient.get<PaginatedMessages>(`/chat/conversations/${conversationId}/messages?page=${page}&size=${size}`),

  markMessagesAsRead: (conversationId: string) =>
    apiClient.post<void>(`/chat/conversations/${conversationId}/read`),

  getUnreadCount: (conversationId: string) =>
    apiClient.get<number>(`/chat/conversations/${conversationId}/unread-count`),
};